import api from './api';

export const paymentService = {
  /**
   * Create a Stripe Checkout Session for a course
   * @param {string} courseId - The course ID
   * @param {string} purchaseType - 'INDIVIDUAL' or 'SCHOOL_BULK'
   * @returns {Promise} Checkout session with URL
   */
  createCheckoutSession: async (courseId, purchaseType = 'INDIVIDUAL') => {
    const response = await api.post('/payments/create-checkout-session', {
      courseId,
      purchaseType,
    });
    return response.data;
  },

  /**
   * Create a payment intent for a course (legacy, for Stripe Elements)
   * @param {string} courseId - The course ID
   * @param {string} purchaseType - 'INDIVIDUAL' or 'SCHOOL_BULK'
   * @returns {Promise} Payment intent with clientSecret
   */
  createPaymentIntent: async (courseId, purchaseType = 'INDIVIDUAL') => {
    const response = await api.post('/payments/create-intent', {
      courseId,
      purchaseType,
    });
    return response.data;
  },

  /**
   * Get payment history for the current user
   * @returns {Promise} Payment history
   */
  getPaymentHistory: async () => {
    const response = await api.get('/payments/history');
    return response.data;
  },

  /**
   * Verify payment status by Stripe session ID
   * @param {string} sessionId - The Stripe checkout session ID
   * @returns {Promise} Payment verification result
   */
  verifyPaymentBySession: async (sessionId) => {
    const response = await api.get('/payments/verify-session', {
      params: { sessionId },
    });
    return response.data;
  },
};

